<template>
  <div id="article">
    <div v-if="articleData" class="article-intro">
      <div class="title">{{ articleTitle }}</div>
      <div class="intro">
        <span v-if="source">{{ source }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span v-if="time">{{ time.slice(0, 10) }}</span>
      </div>
      <div v-html="articleData"></div>
    </div>
    <div
      v-if="
        (Number(this.$route.query.type) === 15 ||
          Number(this.$route.query.type) === 16 ||
          Number(this.$route.query.type) === 11) &&
        attachmentArr.length > 0
      "
      class="attachment"
    >
      <div class="title">附件:</div>
      <div class="detail" v-for="(item, index) in attachmentArr" :key="index">
        <div class="img">
          <img :src="fileType(item)" alt="" />
        </div>
        <div class="name" @click="openFile(item)">{{ item.originName }}</div>
      </div>
    </div>
    <no-data :articleData="articleData" :loading="loading" :attachmentArr="attachmentArr"></no-data>
  </div>
</template>

<script>
import NoData from '@/components/NoData';
import PPT from '@/assets/image/ppt.png';
import WORD from '@/assets/image/word.png';
import EXCEL from '@/assets/image/excel.png';
import PDF from '@/assets/image/pdf.png';
import IMAGE from '@/assets/image/image.png';

export default {
  components: {
    NoData,
  },
  props: ['articleData', 'attachmentArr', 'articleTitle', 'source', 'time', 'loading'],
  data() {
    return {
      ppt: PPT,
      word: WORD,
      excel: EXCEL,
      pdf: PDF,
      image: IMAGE,
    };
  },
  watch: {
    $route() {
      if (this.$route.query.detailID) {
        this.getDetail();
      }
    },
  },
  mounted() {
    if (this.$route.query.detailID) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.$emit('getDetail');
    },
    fileType(val) {
      let tempArr = val.originName.split('.');
      let filetype = tempArr[tempArr.length - 1];
      if (filetype === 'pdf') {
        return this.pdf;
      } else if (filetype === 'docx' || filetype === 'doc') {
        return this.word;
      } else if (filetype === 'xlsx' || filetype === 'xls') {
        return this.excel;
      } else if (filetype === 'ppt') {
        return this.ppt;
      } else if (filetype === 'png' || filetype === 'jpg' || filetype === 'jpeg') {
        return this.image;
      }
    },
    openFile(val) {
      window.open(val.path, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';

.article-intro {
  .title {
    font-size: calc-width(20vw);
    font-weight: bold;
    margin-top: calc-width(24vw);
    margin-bottom: calc-width(15vw);
  }

  .intro {
    font-size: calc-width(13vw);
    color: $time-color;
    margin-bottom: calc-width(15vw);
  }
}

.attachment {
  .title {
    font-size: calc-width(16vw);
    color: $primary-color;
  }

  .detail {
    width: 100%;
    height: calc-width(24vw);
    display: flex;
    align-items: center;
    margin-top: calc-width(20vw);

    .img {
      display: inline-block;
      margin-right: calc-width(10vw);
    }

    .name {
      display: inline-block;
      width: calc-width(300vw);
      @include text-over;
    }

    img {
      width: calc-width(24vw);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Article.vue